<template>
    <div>
        <div v-if="balanceSplit.length || balanceCurrencySplit.length" class="row g-3 mb-3">
            <div v-if="balanceSplit.length" class="col-sm-6">
                <div class="bg-light rounded-3 p-3">
                    <p class="small fw-semibold text-muted mb-0">Balance split (EUR)</p>
                    <div ref="balanceSplitChart" style="height:200px"></div>
                </div>
            </div>
            <div v-for="(split, idx) in balanceCurrencySplit" :key="split.owner" class="col-sm-6">
                <div class="bg-light rounded-3 p-3">
                    <p class="small fw-semibold text-muted mb-0">{{ split.owner }}'s currencies</p>
                    <div :ref="'currencyChart_' + idx" style="height:200px"></div>
                </div>
            </div>
        </div>
        <div class="row g-3 mb-3">
            <div class="col-sm-6">
                <div class="bg-light rounded-3 p-3">
                    <p class="small fw-semibold text-muted mb-0">Income by counterparty</p>
                    <div ref="incomeChart" style="height:220px"></div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="bg-light rounded-3 p-3">
                    <p class="small fw-semibold text-muted mb-0">Expense breakdown</p>
                    <div ref="expenseChart" style="height:220px"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts';

const PIE_DEFAULTS = {
    title: { text: null },
    credits: { enabled: false },
    chart: { backgroundColor: 'transparent', style: { fontFamily: 'inherit' } },
    legend: { enabled: false },
    tooltip: {
        headerFormat: '',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br>€{point.y:,.2f} ({point.percentage:.1f}%)',
    },
    plotOptions: {
        pie: {
            colorByPoint: true,
            innerSize: '58%',
            dataLabels: {
                enabled: true,
                format: '<span style="font-size:11px">{point.name}</span><br><span style="font-size:10px;color:#6c757d">€{point.y:,.0f}</span>',
                distance: 14,
                style: { fontWeight: 'normal', textOutline: 'none', color: '#212529' },
                filter: { property: 'percentage', operator: '>', value: 4 },
            },
            borderWidth: 2,
            borderColor: '#f8f9fa',
        },
    },
};

export default {
    name: 'AccountingCharts',

    props: {
        income:               { type: Array, required: true },
        expenses:             { type: Array, required: true },
        balanceSplit:         { type: Array, default: () => [] },
        balanceCurrencySplit: { type: Array, default: () => [] },
    },

    data() {
        return { charts: [] };
    },

    mounted() {
        this.balanceCurrencySplit.forEach((split, idx) => {
            const ref = this.$refs['currencyChart_' + idx];
            const el  = Array.isArray(ref) ? ref[0] : ref;
            if (!el) return;
            this.charts.push(
                Highcharts.chart(el, {
                    ...PIE_DEFAULTS,
                    chart: { ...PIE_DEFAULTS.chart, type: 'pie', margin: [10, 0, 10, 0] },
                    plotOptions: {
                        pie: {
                            ...PIE_DEFAULTS.plotOptions.pie,
                            dataLabels: {
                                ...PIE_DEFAULTS.plotOptions.pie.dataLabels,
                                filter: { property: 'percentage', operator: '>', value: 0 },
                            },
                        },
                    },
                    series: [{ name: split.owner, data: split.data }],
                })
            );
        });

        if (this.balanceSplit.length) {
            this.charts.push(
                Highcharts.chart(this.$refs.balanceSplitChart, {
                    ...PIE_DEFAULTS,
                    chart: { ...PIE_DEFAULTS.chart, type: 'pie', margin: [10, 0, 10, 0] },
                    tooltip: {
                        headerFormat: '',
                        pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br>\u20ac{point.y:,.2f} ({point.percentage:.1f}%)',
                    },
                    plotOptions: {
                        pie: {
                            ...PIE_DEFAULTS.plotOptions.pie,
                            dataLabels: {
                                ...PIE_DEFAULTS.plotOptions.pie.dataLabels,
                                filter: { property: 'percentage', operator: '>', value: 0 },
                            },
                        },
                    },
                    series: [{ name: 'Balance', data: this.balanceSplit }],
                })
            );
        }

        if (this.income.length) {
            this.charts.push(
                Highcharts.chart(this.$refs.incomeChart, {
                    ...PIE_DEFAULTS,
                    chart: { ...PIE_DEFAULTS.chart, type: 'pie', margin: [10, 0, 10, 0] },
                    series: [{ name: 'Income', data: this.income }],
                })
            );
        } else {
            this.$refs.incomeChart.innerHTML = '<p class="text-muted small text-center pt-5">No income data</p>';
        }

        if (this.expenses.length) {
            this.charts.push(
                Highcharts.chart(this.$refs.expenseChart, {
                    ...PIE_DEFAULTS,
                    chart: { ...PIE_DEFAULTS.chart, type: 'pie', margin: [10, 0, 10, 0] },
                    series: [{ name: 'Expenses', data: this.expenses }],
                })
            );
        } else {
            this.$refs.expenseChart.innerHTML = '<p class="text-muted small text-center pt-5">No expense data</p>';
        }
    },

    beforeDestroy() {
        this.charts.forEach(c => c.destroy());
    },
};
</script>
